import { useQuery } from '@tanstack/react-query'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { type SelectFilterProps } from '@/components/select-filter/select-filter'

import { taskSearchFiltersQuery } from '@/lib/queries/business/v1/task/filters/queries'

export const useActionCompletedFilters = () => {
  const navigate = useNavigate()
  const searchParams = useSearch({
    from: '/_app/_dashboard/dashboard/_taskManagement/task-management/action-completed',
  })

  const [searchInputText, setSearchInputText] = useState('')

  const { data: taskSearchFilterData } = useQuery(
    taskSearchFiltersQuery({ keyword: searchInputText, completeStatus: true })
  )

  const assigneeFilterValues = searchParams.assignees ?? []
  const assigneeFilterOption = searchParams.assigneeCondition
  const assigneeFilterData = taskSearchFilterData?.assignees ?? []
  const assigneeFilterItems = assigneeFilterData.map((item) => ({
    ...item,
    filterValue: `${item.filterValue}`,
  }))
  const isFilterApplied = assigneeFilterValues.length > 0

  const resetFilter = () => {
    void navigate({
      to: '/dashboard/task-management/action-completed',
    })
  }

  const searchWithKeyword = useDebouncedCallback((keyword: string) => {
    void navigate({
      to: '/dashboard/task-management/action-completed',
      search: {
        ...searchParams,
        keyword: keyword ? keyword : undefined,
      },
    })
  }, 300)

  const handleChangeSearchInputText = (value: string) => {
    setSearchInputText(value)
    searchWithKeyword(value)
  }

  const handleChangeAssigneeFilterValues: SelectFilterProps['onChangeValue'] = (values) => {
    void navigate({
      to: '/dashboard/task-management/action-completed',
      search: {
        ...searchParams,
        assignees: [...values],
      },
    })
  }

  const handleChangeAssigneeFilterOption: SelectFilterProps['onChangeFilterOption'] = (value) => {
    void navigate({
      to: '/dashboard/task-management/action-completed',
      search: {
        ...searchParams,
        assigneeCondition: value,
      },
    })
  }

  useEffect(() => {
    if (searchParams.keyword) {
      setSearchInputText(searchParams.keyword)
    }
  }, [searchParams])

  return {
    searchInputText,
    assigneeFilterItems,
    assigneeFilterValues,
    assigneeFilterOption,
    isFilterApplied,
    resetFilter,
    handleChangeSearchInputText,
    handleChangeAssigneeFilterValues,
    handleChangeAssigneeFilterOption,
  }
}
